import { AxiosError, AxiosRequestConfig } from "axios"
import HttpClient from "@/api/utils/HttpClient"
import { AuthService } from "@/services/AuthService"
import { requestMiddleware } from "@/api/utils/requestMiddleware"
import errorHandler from "@/services/ErrorService/errorHandler"
import { BackofficeApiError, IErrorPayload } from "./backofficeApiError"

export const backofficeRestClient = HttpClient({
  baseURL: import.meta.env.SO_BACKOFFICE_GATEWAY_URL,
})

const accessRuleInterceptor = requestMiddleware.createRestInterceptor()

backofficeRestClient.interceptors.request.use(async (config) => {
  const { idToken } = await AuthService.getToken()
  config.headers.Authorization = `Bearer ${idToken}`

  return accessRuleInterceptor.request(config)
})

backofficeRestClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError<IErrorPayload>) => {
    const apiError = new BackofficeApiError(error)

    // A 403 means the user has dropped off the VPN, so every other request is
    // about to fail too. Surface it here rather than leaving it to whoever
    // happens to handle this one rejection.
    if (apiError.status === 403) errorHandler.showApiError(apiError)

    return Promise.reject(apiError)
  },
)

export const backofficeRequest = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> =>
  backofficeRestClient({ ...config, ...options }).then(({ data }) => data)
